module.exports = __webpack_public_path__ + "static/media/batman.618457a0.png";